import type {Concept} from 'types';
import type {PartValueRenderer} from 'schema/types';
import {useLocalization} from 'localization';
import {isNullish} from 'schemaDefinition/functions';
import {isAgentSubType} from 'services/utils';
import {FlexBox} from 'components';
import {useTextValue} from 'schema/preview/hooks';

export const AgentTypeRenderer: PartValueRenderer = ({value}) => {
  const {tLoose} = useLocalization();
  const TextValue = useTextValue();

  if (isNullish(value) || !value || typeof value !== 'string') {
    return null;
  }

  if (isAgentSubType(value as Concept)) {
    return (
      <FlexBox>
        <TextValue>{tLoose(`page.agents.add.type.${value}`)}</TextValue>
      </FlexBox>
    );
  }

  return null;
};
